import axios from 'axios';
import swal from 'sweetalert';

const API_URL = process.env.REACT_APP_API_URL || 'https://tv.gkmmedia.com/api';

// Action Types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const LOGOUT = 'LOGOUT';
export const SET_USER = 'SET_USER';

// Login user
export const loginUser = (username, password) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL}/auth/login`, {
      username,
      password
    });

    if (response.data.success) {
      const { user, token } = response.data.data;
      
      // Save to localStorage
      localStorage.setItem('streamToken', token);
      localStorage.setItem('streamUser', JSON.stringify(user));
      
      // Set axios default header
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { user, token }
      });
      
      return { success: true };
    }
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Login failed';
    
    dispatch({
      type: LOGIN_FAILURE,
      payload: errorMessage
    });
    
    return { success: false, error: errorMessage };
  }
};

// Logout user
export const logoutUser = (navigate) => (dispatch) => {
  // Clear localStorage
  localStorage.removeItem('streamToken');
  localStorage.removeItem('streamUser');
  
  // Clear axios header
  delete axios.defaults.headers.common['Authorization'];
  
  dispatch({
    type: LOGOUT
  });
  
  swal('Logged Out', 'You have been logged out successfully', 'success');
  
  // Redirect to login page
  if (navigate) {
    navigate('/login');
  }
};

// Check if user is already logged in (on app load)
export const checkAuthStatus = () => (dispatch) => {
  const token = localStorage.getItem('streamToken');
  const userString = localStorage.getItem('streamUser');
  
  if (token && userString) {
    try {
      const user = JSON.parse(userString);
      
      // Set axios default header
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      dispatch({
        type: SET_USER,
        payload: { user, token }
      });
      
      return true;
    } catch (error) {
      // Invalid stored data, clear it
      localStorage.removeItem('streamToken');
      localStorage.removeItem('streamUser');
      return false;
    }
  }
  
  return false;
};

// Register new user
export const registerUser = (username, email, password, navigate) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL}/auth/register`, {
      username,
      email,
      password
    });

    if (response.data.success) {
      navigate('/login');
    }
  } catch (error) {
    const errorMessage = error.response?.data?.error || 'Registration failed';
    dispatch({
      type: LOGIN_FAILURE,
      payload: errorMessage
    });
  }
};

// Setup default admin (for initial setup)
export const setupDefaultAdmin = () => async () => {
  try {
    const response = await axios.post(`${API_URL}/auth/setup`);
    return response.data;
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.error || 'Setup failed'
    };
  }
};
